import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';
import { personalInfo } from '../content/data';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="section-padding pt-24">
      <div className="container-max">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Column - Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-8"
          >
            <div className="space-y-4">
              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-dm-sans font-bold text-text-slate dark:text-surface-white leading-tight"
              >
                {personalInfo.name}
              </motion.h1>
              
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.4 }}
                className="text-lg sm:text-xl md:text-2xl text-accent-crimson font-medium"
              >
                {personalInfo.tagline}
              </motion.p>
              
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.6 }}
                className="text-base sm:text-lg text-gray-600 dark:text-gray-300 leading-relaxed max-w-lg"
              >
                Swiss stablecoin operations executive based in Zurich. 11 years in CHF stablecoin infrastructure, payments and institutional adoption - including platform operations at Swiss Stablecoin (CHFD) and former Head of Operations at Frankencoin.
              </motion.p>
            </div>

            {/* CTA Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
              className="flex flex-col sm:flex-row gap-4"
            >
              <motion.button
                whileHover={{ y: -3 }}
                whileTap={{ y: 0 }}
                onClick={scrollToContact}
                className="btn-primary flex items-center justify-center space-x-2"
              >
                <Mail size={20} />
                <span>Get in touch</span>
              </motion.button>
              
              {/* Media Kit button - commented out for easy restoration */}
              {/* <motion.button
                whileHover={{ y: -3 }}
                whileTap={{ y: 0 }}
                className="btn-secondary flex items-center justify-center space-x-2"
                onClick={() => window.open('/media-kit.pdf', '_blank')}
              >
                <Download size={20} />
                <span>Media kit</span>
              </motion.button> */}
            </motion.div>
          </motion.div>

          {/* Right Column - Profile Image */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="flex justify-center lg:justify-end"
          >
            <div className="relative">
              {/* Profile image */}
              <div className="w-64 h-64 sm:w-80 sm:h-80 lg:w-96 lg:h-96 rounded-2xl overflow-hidden mx-auto lg:mx-0">
                <img 
                  src="/andreas-lutz-swiss-stablecoin.png" 
                  alt="Andreas Lutz, stablecoin and digital asset infrastructure executive based in Switzerland" 
                  className="w-full h-full object-cover"
                />
              </div>
              
              {/* Floating elements - commented out for easy restoration */}
              {/* <motion.div
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 3, repeat: Infinity }}
                className="absolute -top-4 -right-4 w-16 h-16 bg-secondary-mint rounded-full flex items-center justify-center shadow-lg"
              >
                <span className="text-white font-bold text-sm">8+</span>
              </motion.div>
              
              <motion.div
                animate={{ y: [0, 10, 0] }}
                transition={{ duration: 3, repeat: Infinity, delay: 1.5 }}
                className="absolute -bottom-4 -left-4 w-20 h-20 bg-accent-crimson rounded-full flex items-center justify-center shadow-lg"
              >
                <span className="text-white font-bold text-sm">$2.5B+</span>
              </motion.div> */}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
